<template>
  <div class="mb-3">
  <p>登録します。<br>よろしいでしょうか。</p>
  </div>
  <div class="rental_contract_confirm_notice">
    入力内容の更新ができなくなります。<br>
    スケジュール情報が 「確認済み」に更新されます。
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  setup() {
    return {};
  },
});
</script>
